module.exports = __webpack_public_path__ + "triste.png?fddaf44d926b4a3fa19c7166d1bbcd6a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/emote/triste.png
// module id = 71
// module chunks = 0